import { Skeleton } from "@material-ui/lab";

export default function EditStudentSkeleton() {
    return (
        <>
            <div className="EditStudentInfoDialog-student-container">
                <Skeleton variant="text" width={120} height={32} />
                <Skeleton variant="text" width={120} height={32} />
            </div>
            <div className="EditStudentInfoDialog-form-container">
                <div className='flex-column gap1'>
                    <div className='flex gap-dot5'>
                        <Skeleton variant="rect" width={'100%'} height={56} />
                        <Skeleton variant="rect" width={'100%'} height={56} />
                    </div>
                    <div className='flex gap-dot5'>
                        <Skeleton variant="rect" width={'100%'} height={56} />
                        <Skeleton variant="rect" width={'100%'} height={56} />
                    </div>
                    <div className='flex gap-dot5'>
                        <Skeleton variant="rect" width={'100%'} height={56} />
                        <Skeleton variant="rect" width={'100%'} height={56} />
                    </div>
                    <div className='flex gap-dot5'>
                        <Skeleton variant="rect" width={'100%'} height={56} />
                        <Skeleton variant="rect" width={'100%'} height={56} />
                    </div>
                    <Skeleton variant="rect" width={'100%'} height={56} />
                    <div className="ProgressDialog-bottom-container" >
                        <div className="ProgressDialog-actions" style={{ marginLeft: 'auto' }}>
                            <Skeleton variant="rect" width={100} height={30} />
                            <Skeleton variant="rect" width={100} height={30} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}